import { CircleCheck, Mail } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

import { SubmissionConfirmationProps } from "../types";

const SubmissionConfirmation = ({ result }: SubmissionConfirmationProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-400 apply-to-join__success">
      <div className="apply-to-join__success-icon-container flex items-center justify-center">
        <CircleCheck
          className="apply-to-join__success-icon"
          aria-hidden="true"
        />
      </div>

      <div className="flex flex-col items-center gap-200 text-center">
        <h2 className="apply-to-join__title header-m-medium">
          {t("applications.labels.applicationSubmittedTitle")}
        </h2>

        <p className="apply-to-join__description body-m-regular">
          {result.administratorName ? (
            <Trans
              i18nKey="applications.labels.applicationSubmittedDescriptionWithAdmin"
              values={{ administratorName: result.administratorName }}
              components={{ bold: <strong /> }}
            />
          ) : (
            t("applications.labels.applicationSubmittedDescription")
          )}
        </p>
      </div>

      <div className="apply-to-join__confirmation-box flex items-center gap-200 full-width">
        <div className="apply-to-join__confirmation-icon-container flex items-center justify-center">
          <Mail
            className="apply-to-join__confirmation-icon"
            aria-hidden="true"
          />
        </div>

        <div className="flex flex-col">
          <span className="body-m-medium apply-to-join__confirmation-label">
            {t("applications.labels.confirmationSent")}
          </span>

          <span className="body-m-regular apply-to-join__confirmation-email">
            {result.email}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SubmissionConfirmation;
